import { createAsyncThunk } from "@reduxjs/toolkit";
import { CUSTOMER_HOME_ROUTES } from "../../../constants/customerApiRoutes";
import API from "../../../services/axios";

function buildQueryParams(
  data: Record<string, any>
  // includeZeroFields: string[] = []
): string {
  const params = new URLSearchParams();

  for (const key in data) {
    const value = data[key];

    // const isZeroAllowed = includeZeroFields.includes(key);

    // const shouldInclude =
    //   value !== undefined &&
    //   value !== null &&
    //   value !== "" &&
    //   (value !== 0 || isZeroAllowed);

    if (value) {
      params.append(key, value);
    }
  }

  return params.toString();
}

type getFunctionalityType = {
  searchQuery?: string;
  project_type?: string;
  state_id?: string;
  city_id?: string;
  page: number;
  limit: number;
  minPrice?: string | number;
  maxPrice?: string | number;
  category_id?: string;
  minBedRoom?: string | number;
  maxBedRoom?: string | number;
  minBathRoom?: string | number;
  maxBathRoom?: string | number;
  minTotalArea?: string | number;
  maxTotalArea?: string | number;
  furnished_status?: string | number;
  status?: string | number;
  group_id?: string | number;
  drawnArea?: any[];
  bounds?: any[];
  areas?: string[];
  three_d?: number;
  sort_order?: string;
};

export const getSearchPropertyDetail = createAsyncThunk(
  CUSTOMER_HOME_ROUTES.SEARCH_PROPERTY,
  async (data: getFunctionalityType, { rejectWithValue }) => {
    try {
      const splitSorting = data?.sort_order?.split("_");

      let sortField = "";
      let sortOrder = "";
      if (splitSorting && splitSorting?.length === 3) {
        sortField = splitSorting[0] + "_" + splitSorting[1];
        sortOrder = splitSorting[2];
      } else if (splitSorting) {
        sortField = splitSorting[0];
        sortOrder = splitSorting[1];
      }

      const queryString = buildQueryParams({
        ...data,
        sortField,
        sortOrder,
        sort_order: null,
        drawnArea: null,
        bounds: null,
        areas: null,
      });
      const response = await API.post(
        `${CUSTOMER_HOME_ROUTES.HOME_SEARCH}?${queryString}`,
        {
          drawnArea: data?.drawnArea || data?.bounds,
          areas: data?.areas,
        }
      );
      // const response = await API.post(
      //   `${CUSTOMER_HOME_ROUTES.HOME_SEARCH}?searchQuery=${data?.searchQuery ?? ""}&sortField=${sortField ?? ""}&sortOrder=${sortOrder ?? ""}&group_id=${data?.group_id ?? ""}&state_id=${data?.state_id ?? ""}&city_id=${data?.city_id ?? ""}&category_id=${data?.category_id ?? ""}&page=${data?.page}&limit=${data?.limit}${data?.minPrice !== 0 ? `&minPrice=${data?.minPrice ?? ""}` : ""}${data?.maxPrice !== 0 ? `&maxPrice=${data?.maxPrice ?? ""}` : ""}${data?.minBedRoom !== 0 ? `&minBedRoom=${data?.minBedRoom ?? ""}` : ""}${data?.maxBedRoom !== 0 ? `&maxBedRoom=${data?.maxBedRoom ?? ""}` : ""}${data?.minBathRoom !== 0 ? `&minBathRoom=${data?.minBathRoom ?? ""}` : ""}${data?.maxBathRoom !== 0 ? `&maxBathRoom=${data?.maxBathRoom ?? ""}` : ""}${data?.minTotalArea !== 0 ? `&minTotalArea=${data?.minTotalArea ?? ""}` : ""}${data?.maxTotalArea !== 0 ? `&maxTotalArea=${data?.maxTotalArea ?? ""}` : ""}${data?.furnished_status ? `&furnished_status=${data?.furnished_status}` : ""}${data?.status ? `&status=${data?.status}` : ""}${data?.three_d ? `&three_d=${data?.three_d}` : ""}`,
      //   { drawnArea: data?.drawnArea || data?.bounds, areas: data?.areas }
      // );

      // return response?.data;
      return {
        ...response?.data,
        ...(data?.bounds?.length ? { appliedBounds: true } : {}),
      };
    } catch (error: any) {
      if (error?.response && error?.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
